import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {
  Delete_Country,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import "./AddOrionUser.scss"
// Operation_Team

// context: {
//   headers: {
//     "X-GraphQL-Server": "orion", // this triggers the orionLink
//   },
// },

const getOrionPages = gql`
query GetAllPagesWithUserType($userType: String!="Operation_Team") {
  getAllPagesWithUserType(userType: $userType) {
    Name
    Unique_Id
    _id
  
  }
}
 `

const GetById = gql`
 query GetOelplUserByID($id: ID) {
  getOelplUserByID(id: $id) {
    Department
    Email
    Full_Name
    Is_Active
    LR_Center
    LR_Center_Data {
      _id
      Search_Value
      Center_Name
    }
    Mobile
    Password
    UserName
    pageRights {
      Page_Access
      Page_Name
      Page_Id
      _id
    }
  }
}
 `


const AddUser = gql`
 mutation SignupoelplUser($createInput: SignupInput!) {
  signupoelplUser(signupInput: $createInput) {
    _id
    Unique_Id
    Department
    Mobile
    Email
    Search_Value
    Full_Name
    UserName
    Password
    LR_Center
    Is_Active
    createdAt
    updatedAt
  }
}
 `;

const EditOelplUser = gql`
 mutation EditoelplUser($id: ID!, $userInput: SignupInput!) {
  editoelplUser(id: $id, signupInput: $userInput) {
    Department
    Email
    Full_Name
  }
}
 `
const AddOrionAppUser = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Orion App user");
  const Form_Key = "Orion_App_User";
  const formRef = useRef({});
  const [FormData, setFormdata] = useState({});
  const { pushModal, popModal } = useModalContext();
  const [toggle, settoggle] = useState(show ? show : false);
  const [selectedRows, setSelectedRows] = useState([]);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const fielddata = fielddataRedux?.OrionAppUser?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState({});

  const [pages, setPages] = useState([])

  const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();


  // Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const { data: PagesData } = useQuery(getOrionPages,
    {
      skip: TypeOfPortal !== "Add",
      context: {
        headers: {
          "X-GraphQL-Server": "orion", // this triggers the orionLink
        },
      },
      onCompleted: (data) => {
        if (data.getAllPagesWithUserType) {
          const apipages = data.getAllPagesWithUserType?.map(el => {
            return {
              Page_Name: el.Name,
              Page_Id: el._id,
              Page_Access: false,
            }
          });
          setPages(apipages)
        }
      },

    },


  );
  const [CreatingData, { loading: createLoading }] = useMutation(AddUser, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion", // this triggers the orionLink
      },
    },
  });

  const [getCountryById, { loading: getByIdLoading }] = useLazyQuery(GetById, {
    fetchPolicy: "network-only",
    context: {

      headers: {
        "X-GraphQL-Server": "orion", // this triggers the orionLink
      },
    },
  });

  const [EditingData, { loading: editLoading }] = useMutation(EditOelplUser, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion", // this triggers the orionLink
      },
    },
  });

  const [DeletingData, { loading: deleteLoading }] = useMutation(Delete_Country);

  const CountryLoading = createLoading || editLoading || deleteLoading || getByIdLoading;


  const handlePageCheckboxChange = (pageIndex) => {
    setPages((prevPages) =>
      prevPages.map((page, idx) =>
        idx === pageIndex ? { ...page, Page_Access: !page.Page_Access } : page
      )
    );
  };


  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  // Handle errors received from FormInputSectionComponent
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };
  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Country_Master?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
      getFormSectionAndFields().then(() => {
        getCountryById({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let Oelpluser = { ...data?.getOelplUserByID };


          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {

                LR_Center: Oelpluser?.LR_Center_Data,
              },
            },
          });
          Oelpluser.LR_Center = Oelpluser?.LR_Center_Data?.Center_Name;
          setAllFieldsData(Oelpluser);
          const pagesData= Oelpluser.pageRights.map(el => {
            return {
              Page_Name: el.Page_Name,
              Page_Id: el.Page_Id,
              Page_Access: el.Page_Access,
            }
          });
          setPages(pagesData);
          updateValueForm(formRef, Oelpluser);
        });
      });
    }
  }, [fielddata]);


  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);



  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  const variables = usePrepareGraphQLVariables(operationType, fielddata, FormData, selectedRows);
  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
  };

  const submit = async (closeAction) => {
    FormData.LR_Center = FormDataFromRedux?.MasterData[Form_Key]?.LR_Center?._id;
    FormData.pageRights = pages
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: FormData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => { },
      onError: (error) => {
        ErrorToast((error).message);
      },
    });
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };



  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal
        open={toggle}
        onClose={() => settoggle(false)}
        TypeOfPortal={"Confirm"}
      //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
      >
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={CountryLoading}
        />
      </Reactportal>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      submitform={() => {
        Validate_handleSubmit(submit);
      }}
      submitType={submitType}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
            Validate_handleSubmit(SaveAndCloseForAdd);
          }
          : () => {
            Validate_handleSubmit(submit);
          }
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={CountryLoading}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
        >
          <>
            {CountryLoading && <div className="loader-line-div" />}
            <div className="formContainer">
              {inputFields && inputFields?.length > 0 ? (
                inputFields.map((e) => (
                  <div key={e.id} className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        fielddata={allFieldsData}
                        onErrorsChange={handleErrorsChange}
                        TypeOfPortal={TypeOfPortal}
                        formkey={Form_Key}
                        onhandleFormikChange={HanldeChangeonForm}
                        formRef={formRef}
                      />
                    </div>
                  </div>
                ))
              ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
                <p>No form fields available.</p>
              ) : null}
              <div className="orion-pageshow-container">
                <div className="page-names-heading">
                  App Pages
                </div>
                <div className="page-names-conainer">
                  {
                    pages?.length && pages.map((page, idx) => (
                      <label key={idx} style={{ display: "block", marginBottom: "6px", fontSize: "14px", color: "#333" }}>
                        <input
                          type="checkbox"
                          style={{ marginRight: "8px" }}
                          checked={page.Page_Access}
                          onChange={() => handlePageCheckboxChange(idx)}
                        />
                        {page.Page_Name}
                      </label>
                    ))
                  }

                </div>
              </div>
            </div>

          </>
        </Reactportal>
      </div>
    </>
  );
};
export default AddOrionAppUser;
